<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title>
      <span class="headline">Дилер - {{ dealer.name }}</span>
      <v-spacer></v-spacer>
      <v-btn color="warning" text @click="back">Назад</v-btn>
    </v-card-title>
    <v-tabs
        v-model="tab"
        color="green"
        :grow="true"
    >
      <v-tab
          v-for="item in items"
          :key="item.tab"
          :disabled="item.disabled"
          class="inactive-tab"
          active-class="active-tab"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
          v-for="item in items"
          :key="item.tab"
      >
        <component
            :key="dealerId"
            :is="item.component"
            v-bind="{dealerId}"
            @ready="ready"
            @update="name => dealer.name = name"
        ></component>
      </v-tab-item>
    </v-tabs-items>

    <v-overlay
        :value="loading"
        absolute
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import DealerEdit from "@/components/Dealer/DealerEdit";
import DealerUsers from "@/components/Dealer/DealerUsers";

export default {
  name: 'Dealer',
  props: ['dealerId'],
  components: {
    DealerEdit,
    DealerUsers,
  },
  data() {
    return {
      loading: true,
      tab: 0,
      dealer: {
        name: null,
      },
      items: [
        {
          tab: 'Свойства',
          component: 'DealerEdit',
        },
        {
          tab: 'Пользователи',
          component: 'DealerUsers',
        },
      ],
    }
  },
  methods: {
    back() {
      history.back();
    },
    ready(name) {
      this.dealer.name = name;
      this.loading = false;
    },
  },
  watch: {
    dealerId: function () {
      this.tab = 0;
      this.dealer.name = null;
      this.loading = true;
    },
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'dealers', disabled: false, to: '/dealers', exact: true},
      {text: this.dealerId, disabled: true},
    ]);
  },
}
</script>

<style>
.inactive-tab {
  background-color: #eeeeee;
}

.active-tab {
  background-color: white !important;
}
</style>